import { useUIStore } from '@/stores/useUIStore';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';
import { Users, Calendar } from 'lucide-react';

export const CaseStudyDetailModal = () => {
  const { isCaseStudyModalOpen, selectedCaseStudy, closeCaseStudyModal } = useUIStore();
  const { t } = useTranslation();

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      closeCaseStudyModal();
    }
  };

  if (!selectedCaseStudy) {
    return null;
  }

  return (
    <Dialog open={isCaseStudyModalOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold mb-2">{selectedCaseStudy.title}</DialogTitle>
          <div className="flex items-center space-x-6 text-sm text-gray-500">
            <div className="flex items-center">
              <Users className="w-4 h-4 mr-2" />
              <span>{t('caseStudies.beneficiaries', { count: selectedCaseStudy.beneficiaries })}</span>
            </div>
            <div className="flex items-center">
              <Calendar className="w-4 h-4 mr-2" />
              <span>{selectedCaseStudy.duration}</span>
            </div>
          </div>
        </DialogHeader>
        <div className="py-4 space-y-6">
          <div className="relative h-80 w-full rounded-lg overflow-hidden">
            <img 
              src={selectedCaseStudy.image} 
              alt={selectedCaseStudy.title} 
              className="w-full h-full object-cover" 
            />
          </div>
          
          <article className="prose max-w-none">
            <p className='text-lg leading-relaxed'>{selectedCaseStudy.summary}</p>
            <div dangerouslySetInnerHTML={{ __html: selectedCaseStudy.content }} />
          </article>

          {selectedCaseStudy.gallery && selectedCaseStudy.gallery.length > 0 && (
            <div>
                <h3 className="text-xl font-bold mb-4">{t('caseStudies.gallery_title')}</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                    {selectedCaseStudy.gallery.map((image, index) => (
                        <div key={index} className="overflow-hidden rounded-lg">
                            <img src={image} alt={`${selectedCaseStudy.title} gallery image ${index + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />
                        </div>
                    ))}
                </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
